import React, { useEffect, useState } from 'react'
import { useHistory, useParams, withRouter, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../../../../constantes/routes'
import HospitalModal from '../HospitalModal'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import { hospitalsActions } from '../../../../actions/hospitalsActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import validators from '../../../../utils/validationsRegEx'
import { hospitalsTypes } from '../../../../constantes/actionTypes'
import { swalMssgs } from '../../../../constantes/swalMssgs'

const EditHospitalContainer = () => {
  const { id } = useParams()
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const zones = useSelector((state) => state.zones)
  const hospitales = useSelector((state) => state.hospitals)
  const businessunits = useSelector((state) => state.businessunits)

  const [inputs, setinputs] = useState({
    id_Hospital: id,
    codigo: '',
    nombre: '',
    direccion: '',
    poblacion: '',
    provincia: '',
    comunidad_Autonoma: '',
    pais: '',
    idioma: '',
    id_TipoZona: '',
    businessUnits: [],
  })
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto
  const [isLoading, setIsLoading] = useState(true) // Estado de carga

  const dispatch = useDispatch()

  const editHospital = (hospital) =>
    dispatch(hospitalsActions.updateHospital(hospital))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      loadBusinessUnitsAndHospital()
    }
  }, [id])

  const loadBusinessUnitsAndHospital = async () => {
    try {
      setIsLoading(true)

      // Cargar business units primero y esperar a que termine
      await dispatch(businessunitsActions.getAllBusinessUnits())

      // Pequeña pausa para asegurar que Redux ha actualizado el estado
      await new Promise((resolve) => setTimeout(resolve, 300))

      // Luego cargar el hospital
      await getHospitalById(id)

      setIsLoading(false)
    } catch (error) {
      console.error('Error loading data:', error)
      setIsLoading(false)
      toHospital()
    }
  }

  const getHospitalById = async (idHospital) => {
    try {
      // Asegurar que hospitales esté disponible
      if (
        !hospitales ||
        !Array.isArray(hospitales) ||
        hospitales.length === 0
      ) {
        console.error('Hospitals list not available')
        toHospital()
        return
      }

      const hospital = hospitales.find(
        (x) => x.id_Hospital.toString() === idHospital,
      )

      if (!hospital) {
        console.error('Hospital not found')
        toHospital()
        return
      }

      // Obtener business units del estado Redux actualizado
      const currentBusinessUnits = businessunits

      // Función para obtener business units seleccionadas
      const getSelectedBusinessUnits = () => {
        if (
          hospital.id_NegocioUnidades &&
          currentBusinessUnits &&
          Array.isArray(currentBusinessUnits) &&
          currentBusinessUnits.length > 0
        ) {
          const selected = currentBusinessUnits.filter((bu) =>
            hospital.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
          )
          return selected
        }
        return []
      }

      const selectedBusinessUnits = getSelectedBusinessUnits()

      // Actualizar todos los inputs de una vez
      setinputs({
        id_Hospital: hospital.id_Hospital,
        codigo: hospital.codigo || '',
        nombre: hospital.nombre || '',
        direccion: hospital.direccion || '',
        poblacion: hospital.poblacion || '',
        provincia: hospital.provincia || '',
        comunidad_Autonoma: hospital.comunidad_Autonoma || '',
        pais: hospital.pais || '',
        idioma: hospital.idioma || '',
        id_TipoZona: hospital.id_TipoZona || '',
        businessUnits: selectedBusinessUnits,
      })
    } catch (error) {
      console.error('Error getting hospital by id:', error)
      toHospital()
    }
  }

  const closeModal = () => {
    setModalIsOpen(false)
    toHospital()
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      // Extraer IDs de business units - usar verificación más estricta para incluir el ID 0
      const businessUnitsIds =
        inputs.businessUnits && Array.isArray(inputs.businessUnits)
          ? inputs.businessUnits
              .filter((bu) => bu && typeof bu.id_NegocioUnidad !== 'undefined') // Permitir ID 0
              .map((bu) => bu.id_NegocioUnidad)
          : []

      const hospitalData = {
        ...inputs,
        id_NegocioUnidades: businessUnitsIds,
      }
      const { businessUnits, ...finalData } = hospitalData

      const response = await editHospital(finalData)
      if (hospitalsTypes.UPDATE_HOSPITAL_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
      }
    } catch (error) {
      console.error('Submit error:', error)
      swalAlertError(error)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleBusinessUnitsChange = (selectedBusinessUnitsIds) => {
    // Convertir los IDs recibidos a objetos completos de business units
    const selectedBusinessUnits = businessunits.filter((bu) =>
      selectedBusinessUnitsIds.includes(bu.id_NegocioUnidad),
    )

    setinputs((inputs) => ({ ...inputs, businessUnits: selectedBusinessUnits }))
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      validators.hasValue(inputs.codigo) &&
      validators.hasValue(inputs.poblacion) &&
      inputs.businessUnits &&
      Array.isArray(inputs.businessUnits) &&
      inputs.businessUnits.length > 0
    )
  }

  const toHospital = () => {
    history.push(routes.HOSPITALS)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          {!isLoading && businessunits && Array.isArray(businessunits) ? (
            <HospitalModal
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
              inputs={inputs}
              zones={zones}
              businessunits={businessunits}
              handleChange={handleChange}
              handleBusinessUnitsChange={handleBusinessUnitsChange}
              handleSubmit={handleSubmit}
              validateForm={validateForm}
              textBtn={onSubmitText.Guardar}
              isEdit={true}
            />
          ) : (
            <div
              className='loading-container'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                color: 'white',
                fontSize: '18px',
              }}
            >
              <p>Cargando datos del hospital...</p>
            </div>
          )}
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}
export default withRouter(EditHospitalContainer)
